export function addTestId(
  id: TestIds,
  suffix?: string
): {
  "data-testid": string;
} {
  return {
    "data-testid": suffix ? `${id}_${suffix}` : id,
  };
}

export enum TestIds {
  SkillTab = "MAIN_CMP_TESTID_SkillTab",
}
